import styled from 'styled-components';

export const IconWrapper = styled.div`
  color: #9d1c49;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
`;
